<template>
	<div class="wrapper">
		<!-- 调用组件  -->
		<div style="background: #fff;padding:0 6px;position: fixed;top:0;left:0;height: 356px;">
			<div class="main-title">基础组件<i class="el-icon-arrow-down"></i></div>
			<div class="be-draggable">
				<draggable element="div" v-model="list1" @end="datadragStart" :options="{sort:false,group:{ name:'people', pull:'clone',put:false}}">
					<div v-for="(item,index) in list1"><i :class="item.className+' icon iconfont'"></i>
						<div class="name">{{item.name}}</div>
					</div>
				</draggable>
			</div>
		</div>
		<!-- 调用组件  -->
		<div class="template-style" :style="'width:'+baseData.width+'px'">
			<draggable element="div" :options="{group:'people',filter: '.undraggable',}" @end="datadragEnd" v-model="baseData.list2">
				<PostElement class="drag-div" @resizeStop="resizeStop" :isDrag="isDrag" :listData="item" :index="index" @chooseDrag="chooseDrag" :key="index" v-for="(item,index) in baseData.list2">
				</PostElement>
			</draggable>
		</div>
		<div class="detail">
			<div class="title"><span @click="changeAdver" :style="tabIndex==0?'color:#F65959;':''">广告设置</span><span :style="tabIndex==1?'color:#F65959':''" @click="changeTab">控件设置</span></div>
			<div class="content" v-if="tabIndex==0">
				<el-form :model="baseData" :rules="rules" ref="form">
					<el-form-item label="宽度：" prop="width" :rules="[ { type: 'number', message: '宽度必须为数字值'}]">
						<el-input  v-model.number="baseData.width"  type="number" class="middle-input" placeholder="宽度,单位(px)"></el-input>PX
					</el-form-item>
					<el-form-item label="批次：" prop="batchNumber">
						<el-input maxlength="30" minlength="5" @change="changeValue" v-model="baseData.batchNumber" :disabled="true" placeholder="请输入数字或字母5-30个字符"></el-input>
					</el-form-item>
					<el-form-item label="标题：" prop="title">
						<el-input maxlength="10" minlength="5" v-model="baseData.title" placeholder="广告标题(5-10个字符)"></el-input>
					</el-form-item>
					<el-form-item label="描述：" prop="desc">
						<el-input  maxlength="30" type="textarea" v-model="baseData.desc" placeholder="请输入描述(可用于分享时文字摘要，30字以内)"></el-input>
					</el-form-item>
					<el-form-item label="分享图片：" prop="imageUrl">
						<el-upload class="avatar-uploader" :action="uploadUrl" name="attachFile" :data="uploadData" :show-file-list="false" :on-success="handleAvatarSuccess">
							<img v-if="baseData.imageUrl" :src="baseData.imageUrl" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>
				</el-form>
				<div class="btn-contain">

					<div @click="saveData('form',0)"  class="save-btn">保存</div>

					<div @click="saveData('form',1)" class="save-btn">提交</div>
					<div @click="preview()"  class="save-btn">预览</div>
				</div>
				<div style="height: 300px;"></div>
			</div>
			<div class="content" v-if="tabIndex==1&&baseData.list2.length>0">
				<div class="sub-title">控件序号：{{activeIndex}}</div>
				<Widget ref="Widget" :userType="userType" :changeImgHeight="changeImgHeight" :uploadUrl="uploadUrl" :width="baseData.width" :data="baseData.list2[activeIndex].detail" @uploadImg="uploadImg" :hotData="baseData.list2[activeIndex].hotData" :disabled="baseData.list2[activeIndex].undraggable" @addHot="addHot" @deleteWidget="deleteWidget" @undraggable="undraggable" @deleteHot="deleteHot" :activeIndex="activeIndex"></Widget>
			</div>
		</div>
		<!-- 输出list数据 -->
	</div>
</template>
<script>
	// 引入拖拽组件
	import draggable from 'vuedraggable';
	import PostElement from '../../components/PostElement'
	import Widget from '../../components/Widget'
	import '../../assets/iconfont.css';
	export default {
		name: 'demo',
		components: {
			PostElement,
			//调用组件
			draggable,
			Widget
		},
		data() {
			return {
				uploadUrl: "",
				activeIndex: 0,
				tabIndex: 0,
				editStatus: false,
				status: 0,
				userType: '0',
				imgUrl: "https://files.evergrande.com/",
				baseData: {
					list2: [],
					width: 375,
					title: "",
					desc: ""
				},
				templeId: "",
				uploadData: {
					type: 'images'
				},
				list1: [{
						key: 0,
						name: '图片1',
						className: 'icon-picture1',
						type: 0,
						hotData: [],
						undraggable: false,
						detail: {
							type: 0
						}
					},
					//					{
					//						key: 1,
					//						name: '图片2',
					//						className: 'icon-picture',
					//						type: 1,
					//						hotData: [],
					//						undraggable: false,
					//						detail: {
					//							type: 1
					//						}
					//					},
					{
						key: 2,
						name: '视频',
						type: 2,
						className: 'icon-video',
						undraggable: false,
						detail: {
							type: 2
						}
					},
					{
						key: 3,
						name: '表单',
						type: 3,
						className: 'icon-form',
						undraggable: false,
						detail: {
							type: 3
						}
					},

				],

				isDrag: false,
				rules: {
					width: [{
							required: true,
							message: '请填写宽度',
							trigger: 'blur'

						},

					],
					batchNumber: [{
							required: true,
							message: '请填写批次号',
							trigger: 'blur',
						},
						{
							min: 5,
							max: 30,
							message: '模板批次(5-30个字符)',
							trigger: 'blur'
						}
					],
					title: [{
							required: true,
							message: '请填写广告标题',
							trigger: 'blur',
						},
						{
							min: 5,
							max: 10,
							message: '广告标题(5-10个字符)',
							trigger: 'blur'
						}
					],
					desc: [{
						min: 0,
						max: 30,
						message: '广告描述30字以内',
						trigger: 'blur'
					}],
					imageUrl: [{
						required: true,
						message: '请上传分享图片',
						trigger: 'change',
					}],

				}

			}
		},
		methods: {
			changeValue(value) {
				this.baseData.batchNumber = value.replace(/[\W]/g, '')
			},
			
			datadragStart() {
				this.list1 = [{
						key: 0,
						name: '图片1',
						className: 'icon-picture1',
						type: 0,
						hotData: [],
						undraggable: false,
						detail: {
							type: 0
						}
					},
					{
						key: 2,
						name: '视频',
						type: 2,
						className: 'icon-video',
						undraggable: false,
						detail: {
							type: 2
						}
					},
					{
						key: 3,
						name: '表单',
						type: 3,
						className: 'icon-form',
						undraggable: false,
						detail: {
							type: 3
						}
					},

				]
			},
			changeAdver() {
				if(this.tabIndex == 1) {
					this.judgeValidate(() => {
						this.tabIndex = 0;
					})
				}
			},
			//判断控件表单是否填完整
			judgeValidate(fn) {
				const that = this;
				new Promise(function(resolve, reject) {
					that.$refs.Widget && that.$refs.Widget.changeValidate(resolve);
				}).then((valid) => {
					if(!valid) {
						that.$message({
							message: '请将表单填写完整',
							type: 'warning'
						});
					} else {
						fn && fn();

					}

				});
			},
			changeTab() {
				if(this.baseData.list2.length == 0) {
					this.$message({
						message: '请先添加控件',
						type: 'warning'
					});

					return
				}

				this.tabIndex = 1;
			},
			handleAvatarSuccess(data) {

				if(data.result) {
					this.$set(this.baseData, 'imageUrl', this.imgUrl + data.value)
				} else {
					this.$message({
						message: data.value,
						type: 'warning'
					});

				}

			},
			//将上传的图片的比例存储起来好做定位
			changeImgHeight(per) {
				this.$set(this.baseData.list2[this.activeIndex].detail, 'per', per);
			},
			uploadImg(data, type, imgHeight) {
				this.$set(this.baseData.list2[this.activeIndex].detail, 'imageUrl' + type, this.imgUrl + data);
				if(imgHeight) {
					this.$set(this.baseData.list2[this.activeIndex].detail, 'height' + type, imgHeight)
				}

			},
			datadragEnd(e, item) {
				this.activeIndex = e.newIndex;
			},
			addHot() {
				this.baseData.list2[this.activeIndex].hotData.push({
					x: 0,
					y: 0,
					w: 50,
					h: 50
				})

			},
			deleteWidget() {
				this.baseData.list2.splice(this.activeIndex, 1);
				this.activeIndex = 0;
				if(this.baseData.list2.length == 0) {
					this.tabIndex = 0;
				}
			},
			//锁定控件先判断是否填写完整
			undraggable() {
				this.judgeValidate(() => {
					this.baseData.list2[this.activeIndex].undraggable = !this.baseData.list2[this.activeIndex].undraggable;
				})

			},
			//选择控件
			chooseDrag(e, index) {
				if(this.activeIndex == index || this.activeIndex == e.newIndex) {
					return
				} else {
					this.judgeValidate(() => {
						if(index >= 0) {
							this.activeIndex = index;
						} else {
							this.activeIndex = e.newIndex;
						}
					})
				}

			},

			resizeStop(index, e, x, y, w, h) {
				this.baseData.list2[index].hotData.splice(e.$attrs.resizeIndex, 1, {
					x: x,
					y: y,
					w: w,
					h: h,
					link: this.baseData.list2[index].hotData[e.$attrs.resizeIndex].link
				})
			},
			judgeNull(str) {
				if(typeof(str) == "undefined" || "" + str == "undefined" || str == null) {
					return false;
				} else {
					return true
				}
			},
			deleteHot(index) {
				this.baseData.list2[this.activeIndex].hotData.splice(index, 1)
			},
			//预览
			preview() {
				this.saveData('form',0,()=>{
					let routeData = this.$router.resolve({
						path: 'preview',
						query: {
							operator: this.$route.query.operator,
							id: this.$route.query.id,
							type:this.$route.query.type
						}
					});
					window.open(routeData.href, '_blank')
				})
			},
			saveData(formName, status, fn) {
				if(this.$refs.Widget||this.judgeNull(this.templeId)) {
					const that = this;
					let url = "";

					this.$refs[formName].validate((valid) => {
						if(valid) {
							let param = {
								id: this.judgeNull(that.templeId) ? that.templeId : '',
								title: this.baseData.title,
								content: JSON.stringify(this.baseData),
								batch_num: this.baseData.batchNumber,
								ad_type: 1,
								status: status,
								operator: this.judgeNull(this.$route.query.operator) ? this.$route.query.operator : ''
							}
							this.Post("/rest/advertisement/operateAdvertisement", param).then((data) => {
								if(data.result) {
									this.$message({
										message: "操作成功",
										type: 'warning'
									});
									if(!that.judgeNull(that.templeId)) {
										that.initData(that.templeId);
									} else {
										that.initData(data.objValue);
										that.templeId = data.objValue;
									}
									fn && fn();

								} else {
									this.$message({
										message: data.value,
										type: 'warning'
									});
								}

							})

						} else {
							this.$message({
								message: '请将表单填写完整',
								type: 'warning'
							});
							return false;
						}
					});

				} else {
					this.$message({
						message: '请将控件信息填写完整',
						type: 'warning'
					});
				}
			},
			initData(id) {
				let url = "";
				this.Post("/rest/advertisement/queryAdvertisement/" + id+"/1").then((data) => {
					if(data.result) {
						this.baseData = eval('(' + data.objValue.content + ')');
						this.editStatus = true;
						this.baseData.list2 = eval('(' + data.objValue.content + ')').list2;
					} else {
						this.$message({
							message: data.value,
							type: 'warning'
						});
					}

				})
			},
		},

		mounted() {
			this.uploadUrl = this.baseUrl + '/rest/common/upload';
			if(this.judgeNull(this.$route.query.level)){
				this.userType = this.$route.query.level;
			}
			
			if(this.judgeNull(this.$route.query.id)) {
				this.templeId = this.$route.query.id;
				this.initData(this.$route.query.id)
			}

		}
	}
</script>
<style scoped lang="less">
	.wrapper {
		display: flex;
		justify-content: center;
		.avatar-uploader {
			position: relative;
			width: 92px;
			height: 92px;
			border: 1px solid #D6D6D6;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 40px;
			color: #D8D8D8;
			img {
				position: absolute;
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
			}
		}
		.main-title {
			font-size: 12px;
			color: #666666;
			letter-spacing: 0;
			text-align: left;
			margin: 11px 0;
			display: flex;
			justify-content: space-between;
			.el-icon-arrow-right {
				line-height: 20px;
			}
		}
		.iconfont {
			font-size: 50px;
			color: #999;
		}
		.be-draggable {
			display: flex;
			/*justify-content: space-between;*/
			width: 168px;
			flex-wrap: wrap;
			align-items: center;
			text-align: center;
			>div {
				display: flex;
				flex-wrap: wrap;
				/*justify-content: space-around;*/
			}
			>div>div {
				width: 78px;
				height: 78px;
				border: 1px dashed #999;
				font-size: 30px;
				line-height: 80px;
				margin: 20px 0;
				margin-right: 4px;
			}
			.name {
				font-size: 12px;
				color: #666666;
				line-height: 30px;
				height: 30px;
			}
		}
		.template-style {
			background: #fff;
			position: relative;
			margin-top: 72px;
			min-width: 375px;
			&>div {
				min-height: 700px;
			}
			.hot-contain {
				position: absolute;
				width: 100%;
				height: 100%;
				top: 0;
				left: 0;
			}
		}
		.detail {
			width: 314px;
			background: #fff;
			position: fixed;
			top: 0;
			right: 0;
			.btn-contain {
				display: flex;
				justify-content: space-between;
			}
			.title {
				display: block;
				height: 40px;
				line-height: 40px;
				font-size: 14px;
				color: #666666;
				text-align: center;
				display: flex;
				span {
					width: 50%;
					border: 1px solid #D6D6D6;
					cursor: pointer;
					&:first-child {
						border-right: none;
					}
				}
			}
			.sub-title {
				color: #333;
				font-size: 16px;
				margin-top: 18px;
				line-height: 30px;
			}
			.content {
				padding: 30px;
				padding-top: 0;
				height: 500px;
				overflow-y: auto;
				padding-bottom: 150px;
			}
			/deep/ textarea {
				width: 254px;
				height: 64px
			}
			/deep/ input {
				width: 254px;
				height: 27px;
			}
			/deep/ .middle-input input,
			/deep/ .middle-input {
				width: 200px;
				margin-right: 10px;
			}
			/deep/ .el-form-item__content {
				line-height: 10px;
			}
			.save-btn {
				text-align: center;
				color: #fff;
				font-size: 16px;
				background: #ce000a;
				border-radius: 4px;
				cursor: pointer;
				width: 28%;
				padding: 8px 4px;
				margin: 40px auto;
				cursor: pointer;
			}
			.cancle-btn {
				text-align: center;
				color: #fff;
				font-size: 16px;
				background: #E9E9E9;
				border-radius: 4px;
				cursor: pointer;
				width: 28%;
				padding: 8px 4px;
				margin: 40px auto;
				cursor: pointer;
			}
		}
	}
	
	.top {
		width: 20px;
		height: 20px;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 2;
		/*兼容ie8-*/
		border: 1px solid blue;
	}
	
	/deep/ textarea {
		font-family: Arial!important;
		font-size: 14px;
	}
</style>


// WEBPACK FOOTER //
// src/views/MakePost/Advertise.vue